import { render, staticRenderFns } from "./AddOnStatusEl.vue?vue&type=template&id=c797fcb6&scoped=true&"
import script from "./AddOnStatusEl.vue?vue&type=script&lang=ts&"
export * from "./AddOnStatusEl.vue?vue&type=script&lang=ts&"
import style0 from "./AddOnStatusEl.vue?vue&type=style&index=0&id=c797fcb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c797fcb6",
  null
  
)

export default component.exports